import {useMemo} from 'react';
import _get from 'lodash/get';

const useFunctionType = auth => {
  const functionType = _get(auth, 'customer.functionType', '');

  return useMemo(
    () => ({
      isSkincare: functionType === 'SKINCARE_PRO',
      isMakeup: functionType === 'MAKEUP',
      isEyewear: functionType === 'EYEWEAR',
    }),
    [functionType]
  );
};

export default useFunctionType;
